import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { environment } from 'environments/environment';

let routes: Routes = [];

if (environment.pdf) {
  routes = [
    { path: '', loadChildren: (): Promise<any> => import('./modules/pdf/pdf.module').then((m: any): any => m.PdfModule) }
  ];
}

if (environment.web) {
  routes = [
    { path: 'espace-client', loadChildren: (): Promise<any> => import('./modules/domusign/domusign.module').then((m: any): any => m.DomusignModule), canActivate: [ AuthGuard ] },
    { path: '', loadChildren: (): Promise<any> => import('./modules/guest/guest.module').then((m: any): any => m.GuestModule) }
  ];
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
